// extracted by mini-css-extract-plugin
module.exports = {"submit":"SubmitButton_submit__2mfzt"};